import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home/Home'

import ServeA1 from '@/components/Serve/A1/A1'
import ServeA2 from '@/components/Serve/A2/A2'
import ServeA3 from '@/components/Serve/A3/A3'
import ServeA4 from '@/components/Serve/A4/A4'

import ExhibitionA1 from '@/components/Exhibition/A1/List'
import ExhibitionA1Detail from '@/components/Exhibition/A1/Detail'

import ExhibitionA2 from '@/components/Exhibition/A2/List'
import ExhibitionA2Detail from '@/components/Exhibition/A2/Detail'

import ExhibitionA4 from '@/components/Exhibition/A4/List'
import ExhibitionA4Detail from '@/components/Exhibition/A4/Detail'

import CollectionA1 from '@/components/Collection/A1/List'
import CollectionA1Detail from '@/components/Collection/A1/Detail'

import CollectionA2 from '@/components/Collection/A2/A2'

import NotFound from '@/components/NotFound/NotFound'

import ActivityA1 from '@/components/Activity/A1/List'
import ActivityA1Detail from '@/components/Activity/A1/Detail'

import ExploreA1 from '@/components/Explore/A1/List'
import ExploreA1Detail from '@/components/Explore/A1/Detail'

import ExploreA2 from '@/components/Explore/A2/List'
import ExploreA2Detail from '@/components/Explore/A2/Detail'

import ExploreA3 from '@/components/Explore/A3/List'
import ExploreA3Detail from '@/components/Explore/A3/Detail'

import ShopA1 from '@/components/Shop/A1/A1'

import NewsA1 from '@/components/News/A1/List'
import NewsA1Detail from '@/components/News/A1/Detail'

import NewsA2 from '@/components/News/A2/List'
import NewsA2Detail from '@/components/News/A2/Detail'

import MuseumAffairsA1 from '@/components/MuseumAffairs/A1/A1'
import MuseumAffairsA2 from '@/components/MuseumAffairs/A2/A2'
import MuseumAffairsA4 from '@/components/MuseumAffairs/A4/A4'

import MuseumAffairsA3 from '@/components/MuseumAffairs/A3/List'
import MuseumAffairsA3Detail from '@/components/MuseumAffairs/A3/Detail'

import Search from '@/components/Search/Search'
Vue.use(Router)

const router =  new Router({
  // history模式，去除URL中#
  // mode: 'history',
  // 解决路由跳转后，不显示在首行
  scrollBehavior() {
    return {x: 0, y: 0};
  },
  routes: [{
    path: '/', name: 'Home', component: Home
  },{
    path: '/ServeA1', name: 'ServeA1', component: ServeA1
  },{
    path: '/ServeA2', name: 'ServeA2', component: ServeA2
  },{
    path: '/ServeA3', name: 'ServeA3', component: ServeA3
  },{
    path: '/ServeA4', name: 'ServeA4', component: ServeA4
  },{
    path: '/ExhibitionA1', name: 'ExhibitionA1', component: ExhibitionA1
  },{
    path:'/ExhibitionA1Detail/:id',name:'ExhibitionA1Detail',component:ExhibitionA1Detail
  },{
    path: '/ExhibitionA2', name: 'ExhibitionA2', component: ExhibitionA2
  },{
    path:'/ExhibitionA2Detail/:id',name:'ExhibitionA2Detail',component:ExhibitionA2Detail
  },{
    path: '/ExhibitionA3', name: 'ExhibitionA3',beforeEnter() { window.open('https://jzbwg.3dwxb.com/#/panoview/1');},
  },{
    path: '/ExhibitionA4', name: 'ExhibitionA4', component: ExhibitionA4
  },{
    path:'/ExhibitionA4Detail/:id',name:'ExhibitionA4Detail',component:ExhibitionA4Detail
  },{
    path: '/CollectionA1', name: 'CollectionA1', component: CollectionA1
  },{
    path:'/CollectionA1Detail/:id',name:'CollectionA1Detail',component:CollectionA1Detail
  },{
    path: '/CollectionA2', name: 'CollectionA2', component: CollectionA2
  },{
    path: '/ActivityA1', name: 'ActivityA1', component: ActivityA1
  },{
    path:'/ActivityA1Detail/:id',name:'ActivityA1Detail',component:ActivityA1Detail
  },{
    path: '/ExploreA1', name: 'ExploreA1', component: ExploreA1
  },{
    path:'/ExploreA1Detail/:id',name:'ExploreA1Detail',component:ExploreA1Detail
  },{
    path: '/ExploreA2', name: 'ExploreA2', component: ExploreA2
  },{
    path:'/ExploreA2Detail/:id',name:'ExploreA2Detail',component:ExploreA2Detail
  },{
    path: '/ExploreA3', name: 'ExploreA3', component: ExploreA3
  },{
    path:'/ExploreA3Detail/:id',name:'ExploreA3Detail',component:ExploreA3Detail
  },{
    path:'/ShopA1',name:'ShopA1',component:ShopA1
  },{
    path:'/NewsA1',name:'NewsA1',component:NewsA1
  },{
    path:'/NewsA1Detail/:id',name:'NewsA1Detail',component:NewsA1Detail
  },{
    path:'/NewsA2',name:'NewsA2',component:NewsA2
  },{
    path:'/NewsA2Detail/:id',name:'NewsA2Detail',component:NewsA2Detail
  },{
    path:'/MuseumAffairsA1',name:'MuseumAffairsA1',component:MuseumAffairsA1
  },{
    path:'/MuseumAffairsA2',name:'MuseumAffairsA2',component:MuseumAffairsA2
  },{
    path:'/MuseumAffairsA4',name:'MuseumAffairsA4',component:MuseumAffairsA4
  },{
    path: '/MuseumAffairsA3', name: 'MuseumAffairsA3', component: MuseumAffairsA3
  },{
    path:'/MuseumAffairsA3Detail/:id',name:'MuseumAffairsA3Detail',component:MuseumAffairsA3Detail
  },{
    path:'/Search',name:'Search',component:Search
  },{
    path: '/:catchAll(.*)',name: 'NotFound',component: NotFound,
  }]
})

router.beforeEach((to, from, next) => {
  // 每次路由跳转前执行的操作
  // console.log('路由跳转前：', from.path, '->', to.path);

  // 在Vue实例挂载之前，设置body的背景色
  document.body.style.backgroundColor = '#ffffff';

  next(); // 必须调用next()来resolve这个钩子
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js